import React, { InputHTMLAttributes, useRef, useState } from 'react';

interface IProperties extends InputHTMLAttributes<HTMLInputElement> {
  onClear: () => void;
}

const SearchBar = (properties: IProperties) => {
  const { value, onClear, ...remainingProperties } = properties;

  const inputReference = useRef<HTMLInputElement>(null);

  const [focused, setFocused] = useState(false);

  const handleOnFocus = () => setFocused(true);

  const handleOnBlur = () => setFocused(false);

  const handleClicDiv = () => inputReference.current?.focus();

  return (
    <div
      className={`h-[48px] bg-theme-gray w-fit flex items-center gap-2 rounded-full px-3 ${
        focused ? 'outline text-theme-white' : ' text-theme-light-gray'
      } outline-2`}
      onFocus={handleOnFocus}
      onBlur={handleOnBlur}
      onClick={handleClicDiv}
    >
      <span className="material-icons cursor-default">search</span>
      <input
        {...remainingProperties}
        value={value}
        ref={inputReference}
        className=" h-full bg-transparent w-[17.25rem] text-sm outline-none"
        type="text"
        placeholder="What do you want to listen to?"
      />
      <span
        className={`material-icons cursor-pointer ${
          value ? 'visible' : 'invisible'
        }`}
        onClick={onClear}
      >
        close
      </span>
    </div>
  );
};

export default SearchBar;
